<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <el-card class="box-card">
              <v-card-text>
                <div class="text-xs-center">
                  <img src="../assets/img/logo-full-text.png" style="width:28%;" />
                </div>
                <el-form ref="form">
                  <el-form-item>
                    <el-input v-model="formLogin.email" placeholder="อีเมลแอดเดรส"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      :type="passwordVisible"
                      v-model="formLogin.password"
                      placeholder="รหัสผ่าน"
                    >
                      <el-button slot="append" :icon="icon" @click="togglePasswordVisible()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
              </v-card-text>
              <v-card-actions class="justify-center">
                <el-button type="primary" @click="submitLogin()">เข้าสู่ระบบ</el-button>
              </v-card-actions>
            </el-card>
          </v-flex>
        </v-layout>
        <v-dialog v-model="isLoading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Loading...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
    <div class="my-2 text-xs-center grey--text">Halalize Co., Ltd © 2019 - 2020</div>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    isLoading: false,
    passwordVisible: "password",
    icon: "far fa-eye",
    formLogin: {
      email: "",
      password: ""
    }
  }),
  props: {},
  methods: {
    togglePasswordVisible() {
      if (this.passwordVisible == "password") {
        this.passwordVisible = "text";
        this.icon = "far fa-eye-slash";
      } else {
        this.passwordVisible = "password";
        this.icon = "far fa-eye";
      }
    },
    submitLogin() {
      this.isLoading = true;

      this.formLogin.email.trim();
      this.formLogin.password.trim();

      this.$store
        .dispatch("Auth/login", this.formLogin)
        .then(res => {
          this.$store.dispatch("Auth/setUser");
          this.isLoading = false;
          this.$router.push("/");
        })
        .catch(err => alert(err));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>